import React from "react";
import { useObserver } from "mobx-react";
import PricingPlan from "./pricePlans";
import { IoIosCloseCircleOutline } from "react-icons/io";

export default function PricingPlanPopup({ popUpInitialValue, handlePopup }) {
  const closeThisPopUP = () => {
    handlePopup();
  };

  const URL = window.location.href;
  const isStudent = URL.includes("company") ? false : true;

  return useObserver(() => (
    <>
      {popUpInitialValue && (
        <div
          onClick={closeThisPopUP}
          className="fixed inset-0 flex items-center justify-center z-[500] bg-black bg-opacity-50 backdrop-blur-sm"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative bg-white flex cursor-default overflow-x-hidden flex-col w-[90%] md:w-[95%] lg:w-[60%] max-h-[95vh] tc3:w-[95%] tc1:w-[95%] tc7:!w-fit md:overflow-y-hidden lg:overflow-y-hidden tc7:!overflow-y-auto overflow-y-auto no-scrollbar rounded-lg shadow-lg"
          >
            {/* Close Button */}
            <div
              onClick={closeThisPopUP}
              className="sticky top-1 z-50 ml-auto mr-2  text-primary cursor-pointer"
            >
              <IoIosCloseCircleOutline size={30} />
            </div>

            {/* Content */}
            <div className="p-1 tc7:px-5  mt-0">
              <PricingPlan
                isStudent1={isStudent}
                buttons={false}
                head={false}
              />
            </div>
          </div>
        </div>
      )}
    </>
  ));
}
